import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Box,
  Chip
} from '@mui/material';
import {
  Flight as FlightIcon,
  Tv as TvIcon,
  Image as ImageIcon
} from '@mui/icons-material';
import { clubService } from '../services';

function DashboardPage() {
  const [clubs, setClubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadClubs();
  }, []);

  const loadClubs = async () => {
    try {
      const data = await clubService.getClubs();
      setClubs(data);
    } catch (error) {
      console.error('Error loading clubs:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Container><Typography>Loading...</Typography></Container>;
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">
          Flight Clubs
        </Typography>
      </Box>

      {clubs.length === 0 ? (
        <Card>
          <CardContent>
            <Typography variant="h6" align="center" color="textSecondary">
              No flight clubs yet. Create your first one!
            </Typography>
          </CardContent>
        </Card>
      ) : (
        <Grid container spacing={3}>
          {clubs.map((club) => (
            <Grid item xs={12} md={6} lg={4} key={club.id}>
              <Card>
                <CardContent>
                  <Typography variant="h5" gutterBottom>
                    {club.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" gutterBottom>
                    {club.airport_name} ({club.icao_code})
                  </Typography>
                  
                  <Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Chip
                      icon={<FlightIcon />}
                      label={`${club.aircraft_count} Aircraft`}
                      size="small"
                    />
                    <Chip
                      icon={<TvIcon />}
                      label={`${club.tv_count} TVs`}
                      size="small"
                    />
                    <Chip
                      icon={<ImageIcon />}
                      label={`${club.image_count} Images`}
                      size="small"
                    />
                  </Box>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    onClick={() => navigate(`/clubs/${club.id}`)}
                  >
                    Manage
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}

export default DashboardPage;












